.addButton {
  color: var(--hcr-button-primary-color);
}

.subcategories {
  margin-top: var(--hcr-spacing-4);
}

.categoryGrid {
  grid-template-columns: 1fr auto;
}

